import React, { Suspense, lazy } from 'react';
import { FeedbackButton } from '../../common/feedback-collector/feedback-button';
var AsyncFeedbackCollector = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_product-search-dialog/async-chunk/feedback-collector" */'./feedback-collector');
});
var ExtensibleFeedbackCollector = function ExtensibleFeedbackCollector() {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(FeedbackButton, {
      onClick: function onClick() {}
    })
  }, /*#__PURE__*/React.createElement(AsyncFeedbackCollector, null));
};
export default ExtensibleFeedbackCollector;